import { useState } from "react"

// La página se maneja como estado interno (no en la URL) a propósito: así
// no queda expuesta como query param recorrible (?page=1,2,3...) por scrapers
// que navegan directo a cada URL en vez de interactuar con el paginador.
export const useUrlPagination = (defaultPage: number = 1) => {
  const [currentPage, setCurrentPage] = useState(defaultPage)

  const setPage = (page: number) => {
    if (page === currentPage) {
      return
    }

    setCurrentPage(page)

    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return { currentPage, setPage }
}
